<template>
	<div class="pb-3">
		<div class="text-center"  v-if="popupBatchUpdate.isLoading">
			<img src="@/assets/loading-logo-animation.gif" style="width: 75px"/>
			
			<p class="font-weight-bold">{{$t('THE_SYSTEM_IS_LOADING')}}</p>
		</div>
		<v-row align="center" class="m-0" v-if="!popupBatchUpdate.isLoading">
			<v-col md="8" class="py-0 d-flex">
				<v-radio-group v-model="popupBatchUpdate.priceExtra.action" @change="changeAction()" row class="mt-0">
					<v-radio :label="$t('FAST_UPDATE')" value="massUpdate" color="primary"></v-radio>
					<v-radio :label="$t('RESTRICTION_BULK_UPDATE')" value="update" color="primary"></v-radio>
					<v-radio :label="$t('DELETE')" value="delete" color="primary"></v-radio>
				</v-radio-group>
			</v-col>
			<v-col class="text-right py-0">
				<v-btn color="primary" @click="confirmUpdateExtraPrice()" :disabled="popupBatchUpdate.isLoading">
					<template>{{ $t("UPDATE") }}</template>
				</v-btn>
			</v-col>
		</v-row>
		<v-row class="m-0" v-if="!popupBatchUpdate.isLoading">
			<v-col md="12" >
				<v-row >
					<v-col md="4" class="py-0">
						<label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;">
							{{ $t("METADATA") }}
						</label>
						<v-select item-text="text" item-value="value" :items="popupBatchUpdate.priceExtra.extraType" v-model="popupBatchUpdate.priceExtra.extraTypeSelected" outlined dense >
							<template slot="no-data">
								<div class="no-data">{{ $t("NO_DATA") }}</div>
							</template>
						</v-select>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;"> 
							{{ $t("ROOM_TYPE")}} *
						</label>
						<v-autocomplete item-text="text" item-value="value" :items="listRoom.filter((x) => x.value != -1)" @change="checkProductUpdate()"
							v-model.lazy="popupBatchUpdate.select.roomType" outlined chips dense multiple>
							<template v-slot:prepend-item>
								<p class="mx-3 mt-1"> <a class="text-primary"
										@click="popupBatchUpdate.select.roomType = listRoom.map(e => e.value); checkProductUpdate()">{{
											$t('SELECT_ALL') }}</a>
									| <a class="text-primary" @click="popupBatchUpdate.select.roomType = []">{{
										$t('UN_SELECT_ALL') }}</a>
								</p>
							</template>

							<template v-slot:selection="{ item, index }">
								<v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs"
									:input-value="item.selected" close
									@click:close="removeChips(index, popupBatchUpdate.select.roomType)" @click="item.select">
									<span>{{ item.text }}</span>
								</v-chip>
								<span v-if="index === 2" class="grey--text caption">(+{{
									popupBatchUpdate.select.roomType.length - 2 }})</span>
							</template>
							<template slot="no-data">
								<div class="no-data">{{ $t("NO_DATA") }}</div>
							</template>
						</v-autocomplete>
					</v-col>
					<v-col>
						<label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;"> {{
							$t("SALE_PACKAGE") }} * </label>
						<v-autocomplete item-text="text" item-value="value" :items="planList" v-model.lazy="popupBatchUpdate.select.ratePlan" outlined @change="checkProductUpdate()"
							chips dense multiple>
							<template v-slot:prepend-item>
								<p class="mx-3 mt-1"> 
									<a class="text-primary" @click="popupBatchUpdate.select.ratePlan = planList.map(e => e.value); checkProductUpdate()">{{ $t('SELECT_ALL') }}</a> | 
									<a class="text-primary" @click="popupBatchUpdate.select.ratePlan = []">{{ $t('UN_SELECT_ALL') }}</a>
								</p>
							</template>
							<template v-slot:selection="{ item, index }">
								<v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs"
									:input-value="item.selected" close @click:close="removeChips(index, popupBatchUpdate.select.ratePlan)"
									@click="item.select">
									<span>{{ item.text }}</span>
								</v-chip>
								<span v-if="index === 2" class="grey--text caption">(+{{ popupBatchUpdate.select.ratePlan.length - 2 }})</span>
							</template>
							<template slot="no-data">
								<div class="no-data">{{ $t("NO_DATA") }}</div>
							</template>
						</v-autocomplete>
					</v-col>
					<v-col>
						<label class="pr-0" style="padding-top: 11px; margin-right: 12px; white-space: nowrap;">
							{{ $t("SALE_CHANNEL") }} *
						</label>
						<v-autocomplete item-text="text" item-value="value" :items="listOTA"
							v-model="popupBatchUpdate.select.ota" outlined dense multiple>
							<template v-slot:prepend-item>
								<p class="mx-3 mt-1"> <a class="text-primary"
										@click="popupBatchUpdate.select.ota = listOTA.map(e => e.value)">{{
											$t('SELECT_ALL') }}</a>
									| <a class="text-primary" @click="popupBatchUpdate.select.ota = []">{{
										$t('UN_SELECT_ALL') }}</a>
								</p>
							</template>
							<template v-slot:selection="{ item, index }">
								<v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs"
									:input-value="item.selected" close
									@click:close="removeChips(index, popupBatchUpdate.select.ota)" @click="item.select">
									<span>{{ item.text }}</span>
								</v-chip>
								<span v-if="index === 2" class="grey--text caption">(+{{
									popupBatchUpdate.select.ota.length - 2 }})</span>
							</template>
							<template slot="no-data">
								<div class="no-data">{{ $t("NO_DATA") }}</div>
							</template>
						</v-autocomplete>
					</v-col>
				</v-row>
			</v-col>
		</v-row>

		<div class="mt-0 config-price" v-if="!popupBatchUpdate.isLoading">
			<!-- Nếu cập nhật theo loại phòng -->
			<template>
				<!-- Nếu là cập nhật -->
				<template v-if="popupBatchUpdate.priceExtra.action == 'update'">
					<template>
						<div class="w-100">
							<div class="d-sticky h-header-table d-flex">
								<div class="mr-auto"> 
									<div class="pb-0 pt-0 h-100 pl-2"> 	
										<div class="small-gutters"> 		
											<div class="d-input-sl text-center font-weight-bold">{{ $t("PERSON_NUMBER")}}</div>	
										</div> 
									</div>
								</div> 
								<div class="small-gutters d-flex"> 	
									<div class="text-center font-weight-bold" :style="item.code === 'MON' ? 'width: 162px' : 'width: 94px'" v-for="item in popupBatchUpdate.daysOfWeek" :key="item.value">{{ item.value }}</div> 	
								</div> 
							</div>
							<div class="px-3" v-for="(room, roomIndex) in popupBatchUpdate.priceExtra.hasRoomRate.filter((r) => popupBatchUpdate.select.roomType.includes(r.roomTypeId)
								&& r.roomRates.filter(rr => popupBatchUpdate.select.ratePlan.includes(rr.ratePlanId) && rr.ota.filter(o => popupBatchUpdate.select.ota.includes(o.ota.id)).length > 0).length > 0
							)">
								<div class="py-2 border-bottom" v-for="(plan, indexPlan) in room.roomRates.filter(item => popupBatchUpdate.select.ratePlan.includes(item.ratePlanId) 
																															&& item.ota.filter(o => popupBatchUpdate.select.ota.includes(o.ota.id)).length > 0)">
									<span class="font-weight-bold text-primary">
										{{room.romTypeNameI18ns.find((x) => x.lang == defaultI18n).name}} - {{ plan.romPlanNameI18ns.find((x) => x.lang == defaultI18n).name }}
									</span>
									<p v-if="`${room.roomTypeId}_${plan.ratePlanId}` in updateErrors" class="protection-rate-error text-danger mb-0">{{updateErrors[`${room.roomTypeId}_${plan.ratePlanId}`]}}</p>
									<div v-for="(detail, indexDetail) in plan.ota.filter(item => popupBatchUpdate.select.ota.includes(item.ota.id))" :class="objectCopy && indexDetail == indCopy && roomIndex == indRoomCopy && indexPlan == indPlanCopy? 'd-active-copy' : ''">
										<b-row class="mt-0">
											<v-col class="pb-0 pt-0" >
												<div style="font-size: 13px" class="d-flex align-center h-100 text-primary"> 
													{{ detail.ota.otaI18n.find((x) => x.lang == defaultI18n).name }}
												</div>
											</v-col>
											<v-col class="text-right pb-0 pt-0">
												<v-btn color="primary" x-small class="ml-1" :title="$t('COPY')" @click="copyMasterOta(detail, roomIndex, indexPlan, indexDetail)" > 
													<i class="icon-copy_all fs-16"></i>
												</v-btn>
												<v-btn color="primary" x-small class="ml-1" :title="$t('PASTE')"  @click="pasteMasterOta(detail)" v-if="objectCopy">
													<i class="icon-content_paste fs-16"></i>
												</v-btn>
											</v-col>
										</b-row>
										<div class="d-datePerson pb-2">
											<span class="copyed">{{$t('COPYED')}}</span>
											<template v-for="(person, indexPerson) in detail.dates" >
												<b-row class="mt-1">
													<v-col class="pb-0 pt-1">
														<div class="text-right">
															<span class="font-weight-bold" v-if="roomIndex === 0 && indexDetail === 0 && indexPerson === 0 && indexPlan === 0"> Master 
																<v-tooltip top>
																	<template v-slot:activator="{ on, attrs }">
																		<i class="icon-info fs-16" v-bind="attrs"
																		v-on="on"></i>
																	</template>
																	<span>{{$t('TOOLTIP_MASTER')}}</span>
																</v-tooltip>
															</span>
															<div class="d-flex align-center justify-content-end d-multiplier" v-else>
																<div class="mr-1">
																	<span class="font-weight-bold"> Master *</span>
																</div>
																<div>
																	<currency-ptd
																		:classC="'input-multiplier v-input__slot mb-0 mx-input py-0 pr-1 rounded'" 
																		:options="multiplierOption"
																		v-model.lazy="person.multiplier"
																	/>
																</div> 
																<span class="font-weight-bold pl-1 pr-1"> + </span>
																<div class="mr-1">
																	<currency-ptd
																		:classC="'input-plus v-input__slot mb-0 mx-input py-0 rounded'" 
																		:options="
																			currency == 'VND' ? priceOptionsVi : priceOptionsEn
																		"
																		v-model.lazy="person.plus"
																	/>
																</div>
																<v-btn color="primary" outlined x-small @click="copyMaster(person)" :title="$t('COPY_BY_FOMULAR')"> 
																	<i class="icon-move_down fs-16"></i>
																</v-btn>
															</div>
														</div>
													</v-col>
												</b-row>
												<div class="d-flex mt-1">
													<div class="mr-auto">
														<div class="small-gutters d-flex">
															<currency-ptd
																@input="deleteCopy(roomIndex, indexPlan, indexDetail)"
																:classC="'d-input-sl text-right v-input__slot mb-0 mx-input py-0 rounded'" 
																:options="{length: 2, precision: 0,}"
																v-model.lazy="person.numberPerson"
																tabindex="1"
															/>
															<v-btn class="ml-1 btl-addPerson" x-small :title="$t('ADD')" @click="addPerson(detail, roomIndex, indexPlan, indexDetail)" color="primary" v-if="indexPerson == 0">
																<i class="icon-add fs-16"></i>
															</v-btn>
															<v-btn class="ml-1 btl-deletePerson" x-small :title="$t('DELETE')" @click="deletePerson(detail.dates, indexPerson, roomIndex, indexPlan, indexDetail)" color="error" v-if="indexPerson != 0">
																<i class="icon-delete fs-16"></i>
															</v-btn>
														</div>
													</div>
													<div class="small-gutters d-flex">
														<div class="pb-0 pt-0 d-flex align-items-center">
															<currency-ptd
																@input="deleteCopy(roomIndex, indexPlan, indexDetail)"
																:classC="[
																	'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
																	`${room.roomTypeId}_${plan.ratePlanId}` in updateErrors && 
																	protectionRateInvalid(room.priceMin, room.priceMax, person.price.find((x) => x.apply == 'MON').value) 
																	? 'protection-border-danger' 
																	: ''
																].filter(Boolean).join(' ')"
																:options="
																	currency == 'VND' ? priceOptionsVi : priceOptionsEn
																"
																v-model.lazy="person.price.find((x) => x.apply == 'MON').value"
																tabindex="2"
															/>
															<v-btn color="primary" @click="copyPriceExtra(person)" class="ml-1" :title="$t('COPY')" icon small><i class="icon-content_paste_go fs-16"></i></v-btn>
														</div>
														<div class="pb-0 pt-0">
															<currency-ptd
																@input="deleteCopy(roomIndex, indexPlan, indexDetail)"
																:classC="[
																	'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
																	`${room.roomTypeId}_${plan.ratePlanId}` in updateErrors && 
																	protectionRateInvalid(room.priceMin, room.priceMax, person.price.find((x) => x.apply == 'TUE').value) 
																	? 'protection-border-danger' 
																	: ''
																].filter(Boolean).join(' ')"
																:options="
																	currency == 'VND' ? priceOptionsVi : priceOptionsEn
																"
																v-model.lazy="person.price.find((x) => x.apply == 'TUE').value"
															/>
														</div>
														<div class="pb-0 pt-0">
															<currency-ptd
																@input="deleteCopy(roomIndex, indexPlan, indexDetail)"
																:classC="[
																	'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
																	`${room.roomTypeId}_${plan.ratePlanId}` in updateErrors && 
																	protectionRateInvalid(room.priceMin, room.priceMax, person.price.find((x) => x.apply == 'WED').value) 
																	? 'protection-border-danger' 
																	: ''
																].filter(Boolean).join(' ')"
																:options="
																	currency == 'VND' ? priceOptionsVi : priceOptionsEn
																"
																v-model.lazy="person.price.find((x) => x.apply == 'WED').value"
															/>
														</div>
														<div class="pb-0 pt-0">
															<currency-ptd
																@input="deleteCopy(roomIndex, indexPlan, indexDetail)"
																:classC="[
																	'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
																	`${room.roomTypeId}_${plan.ratePlanId}` in updateErrors && 
																	protectionRateInvalid(room.priceMin, room.priceMax, person.price.find((x) => x.apply == 'THU').value) 
																	? 'protection-border-danger' 
																	: ''
																].filter(Boolean).join(' ')"
																:options="
																	currency == 'VND' ? priceOptionsVi : priceOptionsEn
																"
																v-model.lazy="person.price.find((x) => x.apply == 'THU').value"
															/>
														</div>
														<div class="pb-0 pt-0">
															<currency-ptd
																@input="deleteCopy(roomIndex, indexPlan, indexDetail)"
																:classC="[
																	'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
																	`${room.roomTypeId}_${plan.ratePlanId}` in updateErrors && 
																	protectionRateInvalid(room.priceMin, room.priceMax, person.price.find((x) => x.apply == 'FRI').value) 
																	? 'protection-border-danger' 
																	: ''
																].filter(Boolean).join(' ')"
																:options="
																	currency == 'VND' ? priceOptionsVi : priceOptionsEn
																"
																v-model.lazy="person.price.find((x) => x.apply == 'FRI').value"
															/>
														</div>
														<div class="pb-0 pt-0">
															<currency-ptd
																@input="deleteCopy(roomIndex, indexPlan, indexDetail)"
																:classC="[
																	'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
																	`${room.roomTypeId}_${plan.ratePlanId}` in updateErrors && 
																	protectionRateInvalid(room.priceMin, room.priceMax, person.price.find((x) => x.apply == 'SAT').value) 
																	? 'protection-border-danger' 
																	: ''
																].filter(Boolean).join(' ')"
																:options="
																	currency == 'VND' ? priceOptionsVi : priceOptionsEn
																"
																v-model.lazy="person.price.find((x) => x.apply == 'SAT').value"
															/>
														</div>
														<div class="pb-0 pt-0 d-flex align-center justify-content-end mr-0">
															<currency-ptd
																@input="deleteCopy(roomIndex, indexPlan, indexDetail)"
																:classC="[
																	'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
																	`${room.roomTypeId}_${plan.ratePlanId}` in updateErrors && 
																	protectionRateInvalid(room.priceMin, room.priceMax, person.price.find((x) => x.apply == 'SUN').value) 
																	? 'protection-border-danger' 
																	: ''
																].filter(Boolean).join(' ')"
																:options="
																	currency == 'VND' ? priceOptionsVi : priceOptionsEn
																"
																v-model.lazy="person.price.find((x) => x.apply == 'SUN').value"
															/>
														</div>
													</div>
												</div>
											</template>
										</div>
									</div>
								</div>
							</div>
						</div>
					</template>
					<template  v-if="popupBatchUpdate.priceExtra.hasRoomRate.filter((r) => popupBatchUpdate.select.roomType.includes(r.roomTypeId)
								&& r.roomRates.filter(rr => popupBatchUpdate.select.ratePlan.includes(rr.ratePlanId) && rr.ota.filter(o => popupBatchUpdate.select.ota.includes(o.ota.id)).length > 0).length > 0
							).length == 0">
						<v-col class="text-center">
							<p>{{ $t("NO_DATA") }}</p>
						</v-col>
					</template>
				</template>
				<!-- Nếu là xóa giá -->
				<template v-else-if="popupBatchUpdate.priceExtra.action == 'delete'">
					<template>
						<div>
							<div class="d-sticky h-header-table d-flex px-2">
								
								<div class="pb-0 pt-0"> 	
									<div class="small-gutters d-flex"> 	
										<div class="text-center font-weight-bold" :style="index ===0 ? 'width: 130px; padding-right: 20px' : 'width: 94px' " v-for="(item, index) in popupBatchUpdate.daysOfWeek" :key="item.value">{{ item.value }}</div>	
									</div> 
								</div>
								<div class="ml-auto">
									<div class="small-gutters d-flex"> 	
										<div class="text-center font-weight-bold d-input-sl text-nowrap">{{ $t("PERSON_NUMBER") }}</div>	
									</div> 
								</div> 
							</div>
							<div class="mt-1 px-2" v-for="(room, roomIndex) in popupBatchUpdate.priceExtra.delete.hasRoomRate.filter((temp) => popupBatchUpdate.select.roomType.includes(temp.roomTypeId) 
								&& temp.roomRates.filter(item => popupBatchUpdate.select.ratePlan.includes(item.ratePlanId)).length > 0 
								&& temp.roomRates.filter(item => popupBatchUpdate.select.ratePlan.includes(item.ratePlanId)).filter(rr => rr.ota.filter(o => popupBatchUpdate.select.ota.includes(o.ota.id)).length > 0).length > 0
								)">
								<div
									class="pb-0 pt-3"
									v-for="(plan, indexPlan) in room.roomRates.filter(item => popupBatchUpdate.select.ratePlan.includes(item.ratePlanId) 
																															&& item.ota.filter(o => popupBatchUpdate.select.ota.includes(o.ota.id)).length > 0)"
								>
									<span class="font-weight-bold text-primary">
										{{room.romTypeNameI18ns.find((x) => x.lang == defaultI18n).name}} - {{ plan.romPlanNameI18ns.find((x) => x.lang == defaultI18n).name }}
									</span>
									<div class="py-2" v-for="(detail, indexDetail) in plan.ota.filter(item => popupBatchUpdate.select.ota.includes(item.ota.id))">
										<div class="d-flex">
											<div class="mr-auto text-primary">
												{{
													detail.ota.otaI18n.find((x) => x.lang == defaultI18n)
														.name
												}}
											</div>
											<div class="mr-0 d-flex pr-2">
												<v-btn color="primary" 
													x-small
													class="ml-1"
													:title="$t('COPY')"
													@click="copyRow(detail)"
													>
													<i class="icon-copy_all fs-16"></i>
												</v-btn> <br>
												<v-btn color="primary"
													x-small
													class="ml-1"
													:title="$t('PASTE')"
													@click="pasteRow(detail)"
													v-if="rowCopy"
													>
													<i class="icon-content_paste fs-16"></i>
												</v-btn>
											</div>
										</div>
										<div class="pb-0 pt-1">
											<div class="small-gutters d-flex row-delete-rate">
												<div>
													
													<b-form-select
														v-model="detail.dates.find((x) => x.apply == 'MON').value"
														:options="popupBatchUpdate.priceExtra.delete.options"
														value-field="value"
														text-field="text"
														size="sm"
														class="w-input-update"
													></b-form-select>
													<v-btn color="primary" @click="copyCol(detail)" class="ml-1"
													:title="$t('COPY')" icon small><i
														class="icon-content_paste_go fs-16"></i></v-btn>
												</div>
												<div>
													<b-form-select
														text-field="text"
														value-field="value"
														:options="popupBatchUpdate.priceExtra.delete.options"
														v-model="
															detail.dates.find((x) => x.apply == 'TUE').value
														"
														size="sm"
														class="w-input-update"
													></b-form-select>
												</div>
												<div>
													<b-form-select
														text-field="text"
														value-field="value"
														:options="popupBatchUpdate.priceExtra.delete.options"
														v-model="
															detail.dates.find((x) => x.apply == 'WED').value
														"
														size="sm"
														class="w-input-update"
													></b-form-select>
												</div>
												<div>
													<b-form-select
														text-field="text"
														value-field="value"
														:options="popupBatchUpdate.priceExtra.delete.options"
														v-model="
															detail.dates.find((x) => x.apply == 'THU').value
														"
														size="sm"
														class="w-input-update"
													></b-form-select>
												</div>
												<div>
													<b-form-select
														text-field="text"
														value-field="value"
														:options="popupBatchUpdate.priceExtra.delete.options"
														v-model="
															detail.dates.find((x) => x.apply == 'FRI').value
														"
														size="sm"
														class="w-input-update"
													></b-form-select>
												</div>
												<div>
													<b-form-select
														text-field="text"
														value-field="value"
														:options="popupBatchUpdate.priceExtra.delete.options"
														v-model="
															detail.dates.find((x) => x.apply == 'SAT').value
														"
														size="sm"
														class="w-input-update"
													></b-form-select>
												</div>
												<div>
													<b-form-select
														text-field="text"
														value-field="value"
														:options="popupBatchUpdate.priceExtra.delete.options"
														v-model="
															detail.dates.find((x) => x.apply == 'SUN').value
														"
														size="sm"
														class="w-input-update"
													></b-form-select>
												</div>
												<div class="ml-auto">
													<currency-ptd
															:classC="'d-input-sl text-right v-input__slot mb-0 mx-input py-0 rounded text-right pr-3'" 
															:options="{
																length: 2,
																precision: 0,
															}"
															v-model.lazy="detail.numberPerson"
														/>
												</div>
											</div>
										</div>
									</div>
									<hr class="mb-0" />
								</div>
							</div>
						</div>
					</template>
					<template v-if="popupBatchUpdate.priceExtra.delete.hasRoomRate.filter((temp) => popupBatchUpdate.select.roomType.includes(temp.roomTypeId) 
					&& temp.roomRates.filter(item => popupBatchUpdate.select.ratePlan.includes(item.ratePlanId)).length > 0 
					&& temp.roomRates.filter(item => popupBatchUpdate.select.ratePlan.includes(item.ratePlanId)).filter(rr => rr.ota.filter(o => popupBatchUpdate.select.ota.includes(o.ota.id)).length > 0).length > 0
					).length === 0">
						<v-col class="text-center">
							<p>{{ $t("NO_DATA") }}</p>
						</v-col>
					</template>
				</template>

				<template v-else>
					<template>
						<div class="w-100">
							<div class="d-un-sticky h-header-table d-flex">
								<div class="mr-auto"> 
									<div class="pb-0 pt-0 h-100 pl-2"> 	
										<div class="small-gutters"> 		
											<div class="d-input-sl text-center font-weight-bold">{{ $t("PERSON_NUMBER")}}</div>	
										</div> 
									</div>
								</div> 
								<div class="small-gutters d-flex"> 	
									<div class="text-center font-weight-bold" :style="item.code === 'MON' ? 'width: 162px' : 'width: 94px'" v-for="item in popupBatchUpdate.daysOfWeek" >{{ item.value }}</div> 	
								</div> 
							</div>
							<div class="d-flex mt-1 px-2" v-for="(person, indexPerson) in massDate" :key="indexPerson">
								<div class="mr-auto">
									<div class="small-gutters">
										<div class="pb-0 pt-0 d-flex align-items-center">
											<currency-ptd :classC="'d-input-sl text-right v-input__slot mb-0 mx-input py-0 rounded text-right pr-2'"  :options="{ length: 2, precision: 0, }" v-model.lazy="person.numberPerson"/>
											<v-btn class="ml-1 btl-addPerson" x-small :title="$t('ADD')" @click="addPersonMass( massDate[massDate.length - 1].numberPerson )" color="primary" v-if="indexPerson == 0">
												<i class="add-person icon-add fs-16" ></i>
											</v-btn>
											<v-btn class="ml-1 btl-deletePerson" x-small :title="$t('DELETE')" @click="deletePersonMass(indexPerson)" color="error" v-if="indexPerson != 0">
												<i  class="delete-person icon-delete fs-16"></i>
											</v-btn>		
										</div> 	
									</div>
								</div>
								<div class="small-gutters d-flex position-relative" :class="{'mb-5': person.numberPerson in updateErrors}">
									<div class="pb-0 pt-0 d-flex align-items-center">
										<currency-ptd 
										:classC="[
											'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
											`${person.numberPerson}` in updateErrors && 
											protectionRateInvalid(null, minRate, person.price.find((x) => x.apply == 'MON').value) 
											? 'protection-border-danger' 
											: ''
										].filter(Boolean).join(' ')"  
										:options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" 
										v-model.lazy="person.price.find((x) => x.apply == 'MON').value"
										/>
										<v-btn color="primary" @click="copyPriceExtraMass(indexPerson)" class="ml-1" :title="$t('COPY')" icon small><i class="icon-content_paste_go fs-16"></i></v-btn>
									</div>
									<div class="pb-0 pt-0">
										<currency-ptd 
										:classC="[
											'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
											`${person.numberPerson}` in updateErrors && 
											protectionRateInvalid(null, minRate, person.price.find((x) => x.apply == 'TUE').value) 
											? 'protection-border-danger' 
											: ''
										].filter(Boolean).join(' ')"  
										:options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" 
										v-model.lazy="person.price.find((x) => x.apply == 'TUE').value"
										/>
									</div>
									<div class="pb-0 pt-0">
										<currency-ptd 
										:classC="[
											'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
											`${person.numberPerson}` in updateErrors && 
											protectionRateInvalid(null, minRate, person.price.find((x) => x.apply == 'WED').value) 
											? 'protection-border-danger' 
											: ''
										].filter(Boolean).join(' ')"  
										:options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" 
										v-model.lazy="person.price.find((x) => x.apply == 'WED').value"
										/>
									</div>
									<div class="pb-0 pt-0">
										<currency-ptd 
										:classC="[
											'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
											`${person.numberPerson}` in updateErrors && 
											protectionRateInvalid(null, minRate, person.price.find((x) => x.apply == 'THU').value) 
											? 'protection-border-danger' 
											: ''
										].filter(Boolean).join(' ')"  
										:options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" 
										v-model.lazy="person.price.find((x) => x.apply == 'THU').value"
										/>
									</div>
									<div class="pb-0 pt-0">
										<currency-ptd 
										:classC="[
											'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
											`${person.numberPerson}` in updateErrors && 
											protectionRateInvalid(null, minRate, person.price.find((x) => x.apply == 'FRI').value) 
											? 'protection-border-danger' 
											: ''
										].filter(Boolean).join(' ')"  
										:options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" 
										v-model.lazy="person.price.find((x) => x.apply == 'FRI').value"
										/>
									</div>
									<div class="pb-0 pt-0">
										<currency-ptd 
										:classC="[
											'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
											`${person.numberPerson}` in updateErrors && 
											protectionRateInvalid(null, minRate, person.price.find((x) => x.apply == 'SAT').value) 
											? 'protection-border-danger' 
											: ''
										].filter(Boolean).join(' ')"  
										:options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" 
										v-model.lazy="person.price.find((x) => x.apply == 'SAT').value"
										/>
									</div>
									<div class="mr-0">
										<currency-ptd 
										:classC="[
											'w-input-update text-right v-input__slot mb-0 mx-input py-0 rounded', 
											`${person.numberPerson}` in updateErrors && 
											protectionRateInvalid(null, minRate, person.price.find((x) => x.apply == 'SUN').value) 
											? 'protection-border-danger' 
											: ''
										].filter(Boolean).join(' ')"  
										:options="currency == 'VND' ? priceOptionsVi : priceOptionsEn" 
										v-model.lazy="person.price.find((x) => x.apply == 'SUN').value"
										/>
									</div>
									<div class="m-0 mt-13 protection-rate-error text-danger position-absolute" v-if="`${person.numberPerson}` in updateErrors">{{updateErrors[`${person.numberPerson}`]}}</div>
								</div>
							</div>
						</div>
					</template>
				</template>
			</template>
		</div>
		<div class="text-right pt-3 px-3" v-if="!popupBatchUpdate.isLoading">
			<v-btn color="primary" @click="confirmUpdateExtraPrice()">
				<template>{{ $t("UPDATE") }}</template>
			</v-btn>
		</div>
		<v-dialog v-model="dialogWarning" :persistent="true" width="500" >
			<v-toolbar class="toolbar-update" dense >
				<v-toolbar-title class="text-primary fs-15">
				<strong>{{ $t('WARNING') }}</strong>
				</v-toolbar-title>
			</v-toolbar>
			<div class="content-update">
				<label class="s-label">
				{{ $t('TXT_WARNING_OVER') }}
				</label>
				<div class="mt-3 text-center">
					<v-btn color="primary" @click="closeWarning">
					{{ $t("CONFIRM") }}
					</v-btn>
				</div>
			</div>
		</v-dialog>
	</div>
</template>
<style lang="scss" scoped>
	.btn-copy-paste{
		opacity: 0;
	}
	.row-delete-rate:hover {
		.btn-copy-paste {
			opacity: 1;
		}
	}
</style>
<script>
import { _alert } from "@/_helpers/function.js";
import { sale_room } from "@/_services/SaleRoom/sale-room.js";
import { restriction } from "@/_services/SaleRoom/restriction.js";
import { syncota } from "@/_services/SyncOTA/syncota.js";
export default {
	components: {
		"currency-ptd": () => import('@/components/Utils/Currency-input.vue'),
	},
	data() {
		return {
			dialogWarning: false,
			rowCopy: null,
			planList: [],
			listOTA: [],
			panel: [0],
			systemLang: this.$i18n.locale,
			listRoom: [], // Danh sách các phòng, do dữ liệu roomData cấu thành list
			multiplierOption: {
				prefix: "",
				locale: "vi",
				length: 3,
				precision: 2,
			},
			popupBatchUpdate: {
				isLoading: true,
				batchUpdateDialog: false,
				currentTabIndex: -1,
				currentRoomtypeIds: null,
				avail: {
					roomSelect: [],
					listOfPeriod: [],
					invalidDate: false,
				},
				priceExtra: {
					hasRoomRate: [],
					roomRateSelect: [],
					extraType: [
						{ value: 0, text: this.$t("priceExtraAdult") },
						{ value: 1, text: this.$t("priceExtraChild") },
						{ value: 2, text: this.$t("priceExtraBaby") },
					],
					extraTypeSelected: 0,
					action: "massUpdate",
					delete: {
						hasRoomRate: [],
						options: [
							{ text: this.$t('DELETE'), value: -1 },
							{ text: this.$t('_ACTIVITY.NO'), value: null },
						],
					},
					selectedRoomType: [],
				},
				daysOfWeek: [
					{ code: "MON", value: this.$t("MONDAY") },
					{ code: "TUE", value: this.$t("TUESDAY") },
					{ code: "WED", value: this.$t("WEDNESDAY") },
					{ code: "THU", value: this.$t("THURSDAY") },
					{ code: "FRI", value: this.$t("FRIDAY") },
					{ code: "SAT", value: this.$t("SATURDAY") },
					{ code: "SUN", value: this.$t("SUNDAY") },
				],
				select: {
					roomType: [],
					ratePlan: [],
					ota: []
				}
			},
			objectCopy: null,
			 massDate: [
				{
					numberPerson: 1,
					price: [
						{
							apply: "MON",
							value: null
						},
						{
							apply: "TUE",
							value: null
						},
						{
							apply: "WED",
							value: null
						},
						{
							apply: "THU",
							value: null
						},
						{
							apply: "FRI",
							value: null
						},
						{
							apply: "SAT",
							value: null
						},
						{
							apply: "SUN",
							value: null
						}
					]
				}
			],
			indCopy: null,
			indRoomCopy: null,
			indPlanCopy: null,
			updateErrors: {},
			minRate: null,
		};
	},
	computed: {
	},
	created() {
		this.initialize();
	},
	watch: {
		popupBatchUpdate: {
			handler(val) {
				val.priceExtra.hasRoomRate.forEach(room => {
					const arrRoomRateIds = [];
					room.roomRates.forEach(plan => {
						plan.ota.forEach(detail => {
							arrRoomRateIds.push(detail.roomrateId);
						});
					});
					let check = true
					arrRoomRateIds.forEach(item => {
						if (!val.priceExtra.roomRateSelect.includes(item)) {
							check = false
						}
					})
					room.selectAll = check
				});
				this.updateErrors = {};
			},
			deep: true
		},
	},
	methods: {
		checkValidate() {
			this.updateErrors = {};
			if (['massUpdate', 'update'].includes(this.popupBatchUpdate.priceExtra.action)) {
				if (this.popupBatchUpdate.priceExtra.action == 'massUpdate') {
					let minRate = this.popupBatchUpdate.priceExtra.hasRoomRate
					.filter(item => this.popupBatchUpdate.select.roomType.includes(item.roomTypeId) && item.priceMax !== null && item.priceMax !== '')
					.reduce((min, item) => Math.min(min, item.priceMax), Infinity);
					this.minRate = minRate >= 0 ? minRate : null;
					this.massDate.forEach(({ numberPerson, price }) => {
						for (const { value } of price) {
							if (value !== null && this.minRate !== null && value > this.minRate) {
								this.updateErrors[numberPerson] = this.$t("SAFE_PRICE_RANGE.MAXIMUM_RATE_INPUT_INVALID", {priceMax: this.formatCurrencyWithSymbol(this.minRate)});
								break;
							}
						}
					});
				}

				if (this.popupBatchUpdate.priceExtra.action == 'update') {
					const errors = new Map();

					const roomRate = this.popupBatchUpdate.priceExtra.hasRoomRate.filter(
						item => this.popupBatchUpdate.select.roomType.includes(item.roomTypeId)
					);

					roomRate.forEach(room => {
						room.roomRates
							.filter(rate => this.popupBatchUpdate.select.ratePlan.includes(rate.ratePlanId))
							.forEach(rate => {
								const id = `${room.roomTypeId}_${rate.ratePlanId}`;

								if (!errors.has(id)) {
									const hasInvalidPrice = rate.ota
										.filter(o => this.popupBatchUpdate.select.ota.includes(o.ota.id))
										.some(o =>
											o.dates.some(date =>
												date.price.some(day => day.value && room.priceMax && day.value > room.priceMax)
											)
										);

									if (hasInvalidPrice) {
										errors.set(
											id,
											this.$t("SAFE_PRICE_RANGE.MAXIMUM_RATE_INPUT_INVALID", {
												priceMax: this.formatCurrencyWithSymbol(room.priceMax),
											})
										);
									}
								}
							});
					});

					if (errors.size > 0) {
						this.updateErrors = Object.fromEntries(errors);
					}
				}
				return Object.keys(this.updateErrors).length == 0;
			}
			return true;
		},
		closeWarning() {
			this.popupBatchUpdate.select.ratePlan = [];
			this.dialogWarning = false
		},
		checkProductUpdate() {
			let dataUpdate = 0;
			if (this.popupBatchUpdate.priceExtra.action !== 'massUpdate') {
				 this.popupBatchUpdate.priceExtra.hasRoomRate.forEach(e => {
					if ( this.popupBatchUpdate.select.roomType.includes(e.roomTypeId)) {
						
						e.roomRates.forEach(rr => {
							if( this.popupBatchUpdate.select.ratePlan.includes(rr.ratePlanId)) {
								dataUpdate += 1;
							}
						})
					}
				 });
			}
			if (dataUpdate > 50) {
				this.dialogWarning = true;
			}
		},
		changeAction() {
			this.popupBatchUpdate.select.ratePlan = []
		},
		copyCol(detail) {
			const value = detail.dates.find((x) => x.apply == 'MON').value;
			detail.dates[0].value = value;
			detail.dates[1].value = value;
			detail.dates[2].value = value;
			detail.dates[3].value = value;
			detail.dates[4].value = value;
			detail.dates[5].value = value;
			detail.dates[6].value = value;
		},
		copyRow(detail) {
			this.rowCopy = [...detail.dates];
		},
		pasteRow(detail) {
			if (this.rowCopy) {
				detail.dates[0].value = this.rowCopy[0].value;
				detail.dates[1].value = this.rowCopy[1].value;
				detail.dates[2].value = this.rowCopy[2].value;
				detail.dates[3].value = this.rowCopy[3].value;
				detail.dates[4].value = this.rowCopy[4].value;
				detail.dates[5].value = this.rowCopy[5].value;
				detail.dates[6].value = this.rowCopy[6].value;
			}
		},
		async initialize() {
			this.popupBatchUpdate.isLoading = true;
			const ob = [
						{ value: 0, text: "priceExtraAdult"},
						{ value: 1, text: "priceExtraChild"},
						{ value: 2, text: "priceExtraBaby"},
					];
			if (this.$route.query && this.$route.query.metaData) {
				this.popupBatchUpdate.priceExtra.extraTypeSelected = ob.find(e => e.text === this.$route.query.metaData) 
				? ob.find(e => e.text === this.$route.query.metaData).value : 0;
			}
			// Nếu là search thì không lấy lại list OTA nữa, ko dùng OTA đầu tiên như khi mới vào.
			this.currency = this.priceOptionsVi.suffix;
			this.getAllRoomDefault();
		},
		async getAllRoomDefault() {
			this.planList = [];
			await restriction.getAllRoomTyeHasRoomRate().then((res) => {
				if (res.responseCode == 0) {
					
					// List phòng đã có room rate cho cập nhật giá và giá đặc biệt
					this.popupBatchUpdate.priceExtra.selectedRoomType = [];
					res.data.forEach((x) => {
						var tempDelete = {
							roomTypeId: x.id,
							romTypeNameI18ns: x.roomTypeI18n,
							roomRates: [],
							priceMin: x.priceMin,
							priceMax: x.priceMax
						};
						var tempExtra = {
							roomTypeId: x.id,
							romTypeNameI18ns: x.roomTypeI18n,
							roomRates: [],
							selectAll: false,
							priceMin: x.priceMin,
              				priceMax: x.priceMax
						};
						x.ratePlans.forEach((y) => {
							let plan = {
								value: y.id,
								text: y.i18ns.find((y) => y.lang == this.defaultI18n).name,
							};
							this.planList.push(plan);
							this.planList = Array.from(new Set(this.planList.map(JSON.stringify))).map(JSON.parse)
							var temp2Delete = [];
							var temp2Extra = [];
							y.roomRates.filter(o => o.ota.otaCode !== 'EZ_PMS').forEach((z) => {
								temp2Delete.push({
									roomrateId: z.id,
									numberPerson: null,
									dates: [
										{
										apply: "MON",
										value: null,
										},
										{
										apply: "TUE",
										value: null,
										},
										{
										apply: "WED",
										value: null,
										},
										{
										apply: "THU",
										value: null,
										},
										{
										apply: "FRI",
										value: null,
										},
										{
										apply: "SAT",
										value: null,
										},
										{
										apply: "SUN",
										value: null,
										},
									],
									ota: z.ota,
								});
								temp2Extra.push({
									roomrateId: z.id,
									dates: [
										{
											numberPerson: 1,
											price: [
												{
													apply: "MON",
													value: null,
												},
												{
													apply: "TUE",
													value: null,
												},
												{
													apply: "WED",
													value: null,
												},
												{
													apply: "THU",
													value: null,
												},
												{
													apply: "FRI",
													value: null,
												},
												{
													apply: "SAT",
													value: null,
												},
												{
													apply: "SUN",
													value: null,
												},
											],
											multiplier: 1,
											plus: 0
										},
									],
									ota: z.ota,
								});
							});
							tempDelete.roomRates.push({
								ratePlanId: y.id,
								romPlanNameI18ns: y.i18ns,
								ota: temp2Delete,
							});
							tempExtra.roomRates.push({
								ratePlanId: y.id,
								romPlanNameI18ns: y.i18ns,
								ota: temp2Extra,
							});
						});
						this.popupBatchUpdate.priceExtra.hasRoomRate.push(tempExtra);
						this.popupBatchUpdate.priceExtra.delete.hasRoomRate.push(tempDelete);
					});
					this.loadListRoom(res.data);
					const params = JSON.parse(localStorage.getItem("roomRateUpdate"));
					if (params.roomId) {
						this.popupBatchUpdate.select.roomType =  params.roomId != -1 ? [params.roomId] : [];
						this.popupBatchUpdate.select.ratePlan = params.planId != -1 ? [params.planId] : [];
						this.popupBatchUpdate.select.ota = params.OtaId != -1 ? [params.OtaId] : [];
					} else {
						this.popupBatchUpdate.select.roomType.push(res.data[0].id);
					}
					
					// this.popupBatchUpdate.priceExtra.roomRateSelect.push(this.popupBatchUpdate.priceExtra.hasRoomRate[0].roomRates[0].ota[0].roomrateId);
					this.panel = this.popupBatchUpdate.priceExtra.hasRoomRate.map((k, i) => i)
				}
			});
		},
		loadListRoom(data) {
			this.listRoom = [];
			this.listRoom = this.listRoom.concat(
				data.map((room) => {
					return {
						value: room.id,
						text: room.roomTypeI18n.find((x) => x.lang === this.defaultI18n).name,
					};
				})
			);
			this.getAllOta()
		},
		async getAllOta() {
			await syncota.getAllOTA({ keyword: "", status: 1 }).then((res) => {
					if (res.responseCode === 0) {
						this.listOTA = res.data.filter((x) => x.otaCode !== 'EZ_PMS').map((x) => {
							return {
								value: x.id,
								text: x.otaI18n.find((y) => y.lang == this.defaultI18n).name
							};
						});
						this.listOTA = this.listOTA.filter((x) => x.value);
						this.listOTA.sort((a, b) => a.text.localeCompare(b.text));
						this.popupBatchUpdate.isLoading = false;
						this.$forceUpdate()
					} else {
						this.popupBatchUpdate.isLoading = false;
						_alert(res, this.$t(res.data), false);
					}
				});
		},
		copyPriceExtra(persons) {
			persons.price[1].value = persons.price[0].value;
			persons.price[2].value = persons.price[0].value;
			persons.price[3].value = persons.price[0].value;
			persons.price[4].value = persons.price[0].value;
			persons.price[5].value = persons.price[0].value;
			persons.price[6].value = persons.price[0].value;
		},
		deleteCopy(roomIndex, indexPlan, indexDetail) {
			if (this.indCopy == indexDetail &&
			this.indRoomCopy == roomIndex && 
			this.indPlanCopy == indexPlan) {
				this.objectCopy = null
			}
		},
		addPerson(detail, roomIndex, indexPlan, indexDetail) {
			if (this.indCopy == indexDetail &&
			this.indRoomCopy == roomIndex && 
			this.indPlanCopy == indexPlan) {
				this.objectCopy = null
			}
			const number_person = detail.dates[detail.dates.length - 1].numberPerson;
			detail.dates.push({
				numberPerson: number_person + 1,
				price: [
					{
						apply: "MON",
						value: null,
					},
					{
						apply: "TUE",
						value: null,
					},
					{
						apply: "WED",
						value: null,
					},
					{
						apply: "THU",
						value: null,
					},
					{
						apply: "FRI",
						value: null,
					},
					{
						apply: "SAT",
						value: null,
					},
					{
						apply: "SUN",
						value: null,
					},
				],
				multiplier: 1,
				plus: 0
			});
		},
		deletePerson(arr, index, roomIndex, indexPlan, indexDetail) {
			if (this.indCopy == indexDetail &&
			this.indRoomCopy == roomIndex && 
			this.indPlanCopy == indexPlan) {
				this.objectCopy = null
			}
			arr.splice(index, 1);
		},
		copyMasterOta(detail, roomIndex, indexPlan, ind) {
			this.objectCopy = [...detail.dates];
			this.indCopy = ind;
			this.indRoomCopy = roomIndex;
			this.indPlanCopy = indexPlan;
		},
		pasteMasterOta(detail) {
			if (this.objectCopy) {
				detail.dates.splice(0, detail.dates.length);
				this.objectCopy.forEach(e => {
					const arr = [];
					e.price.forEach(date => {
						arr.push({
							value: date.value,
							apply: date.apply
						});
					})
					detail.dates.push({
						multiplier: e.multiplier,
						numberPerson: e.numberPerson,
						price: arr
					});
				});
			}
		},
		copyMaster(person) {
			let arrMap = [];
			this.popupBatchUpdate.priceExtra.hasRoomRate
				.filter((temp) => this.popupBatchUpdate.select.roomType.includes(temp.roomTypeId))
				.forEach(r => {
					r.roomRates.filter(rr => this.popupBatchUpdate.select.ratePlan.includes(rr.ratePlanId))
					.forEach(o => {
						o.ota.filter(oo => this.popupBatchUpdate.select.ota.includes(oo.ota.id))
						.forEach(item => {
							arrMap.push(item.dates[0].price)
						})
					})
				})
			person.price.forEach((element, index) => {
				element.value = person.multiplier*arrMap[0][index].value + +person.plus;
			});
		},
		deletePersonMass(indexPerson) {
			this.massDate.splice(indexPerson, 1);
		},
		addPersonMass(number_person) {
			this.massDate.push({
				numberPerson: +number_person + 1,
				price: [
					{
						apply: "MON",
						value: null,
					},
					{
						apply: "TUE",
						value: null,
					},
					{
						apply: "WED",
						value: null,
					},
					{
						apply: "THU",
						value: null,
					},
					{
						apply: "FRI",
						value: null,
					},
					{
						apply: "SAT",
						value: null,
					},
					{
						apply: "SUN",
						value: null,
					},
				],
			});
		},
		copyPriceExtraMass(index) {
			
			this.massDate[index].price.forEach((e, ind) => {
				if (ind !== 0) {
					e.value = this.massDate[index].price[0].value;
				}
			});
		}, 
		confirmUpdateExtraPrice() {
			if (!this.checkValidate()) return;

			let body = [];
			let bodyMassUpdate = {};
			if (this.popupBatchUpdate.select.roomType.length === 0 || this.popupBatchUpdate.select.ratePlan.length === 0 || this.popupBatchUpdate.select.ota.length === 0) {
				_alert("null", this.$t("PLEASE_COMPLETE_THE_FIELDS_MARKED"));
				return
			}
			// if (this.popupBatchUpdate.price.updateBy == "roomtype") {
			if (this.popupBatchUpdate.priceExtra.action == "update") {
				this.popupBatchUpdate.priceExtra.hasRoomRate
					.filter((x) => this.popupBatchUpdate.select.roomType.includes(x.roomTypeId) && x.roomRates.length > 0)
					.forEach((y) => {
						y.roomRates.filter((x) => this.popupBatchUpdate.select.ratePlan.includes(x.ratePlanId) && x.ota).forEach((z) => {
							z.ota.filter((x) => this.popupBatchUpdate.select.ota.includes(x.ota.id) && x.dates).forEach((i) => {
								let tempDate = [];
								i.dates.forEach((t) => {
									if (t.numberPerson) {
										let isValid = false;

										t.price.forEach((u) => {
											if (u.value) {
												isValid = true;
											}
										});
										if (isValid) {
											tempDate.push({
												extraMonday: t.price.find((x) => x.apply == "MON").value,
												extraTuesday: t.price.find((x) => x.apply == "TUE").value,
												extraWednesday: t.price.find((x) => x.apply == "WED").value,
												extraThursday: t.price.find((x) => x.apply == "THU").value,
												extraFriday: t.price.find((x) => x.apply == "FRI").value,
												extraSaturday: t.price.find((x) => x.apply == "SAT").value,
												extraSunday: t.price.find((x) => x.apply == "SUN").value,
												extraType: this.popupBatchUpdate.priceExtra.extraTypeSelected,
												extraOrder: t.numberPerson,
											});
										}
									}
								});
								if (tempDate.length > 0) {
									body.push({
										id: i.roomrateId,
										persons: tempDate,
									});
								}
							});
						});
					});
					
				} else if (this.popupBatchUpdate.priceExtra.action == "massUpdate") { //#region cap nhat hang loat
					this.popupBatchUpdate.priceExtra.roomRateSelect = []
					this.popupBatchUpdate.priceExtra.hasRoomRate.forEach(room => {
						room.roomRates.forEach(plan => {
							plan.ota.forEach(rr => {
								if (this.popupBatchUpdate.select.roomType.includes(room.roomTypeId) 
								&& this.popupBatchUpdate.select.ratePlan.includes(plan.ratePlanId) 
								&& this.popupBatchUpdate.select.ota.includes(rr.ota.id)) {
									this.popupBatchUpdate.priceExtra.roomRateSelect.push(rr.roomrateId)
								}
							})
						})
					})
					if (this.popupBatchUpdate.priceExtra.roomRateSelect.length === 0) {
						return
					} else {
						bodyMassUpdate = {
							ids: [...this.popupBatchUpdate.priceExtra.roomRateSelect],
							persons: []
						};
						this.massDate.forEach(e => {
							if (e.numberPerson) {
								let isValid = false;

								e.price.forEach((u) => {
									if (u.value) {
										isValid = true;
									}
								});
								if (isValid) {
									bodyMassUpdate.persons.push(
										{
											extraMonday: e.price[0].value,
											extraTuesday: e.price[1].value,
											extraWednesday: e.price[2].value,
											extraThursday: e.price[3].value,
											extraFriday: e.price[4].value,
											extraSaturday: e.price[5].value,
											extraSunday: e.price[6].value,
											extraType: this.popupBatchUpdate.priceExtra.extraTypeSelected,
											extraOrder: e.numberPerson,
										}
									);
								}
							} else {
								_alert(null, this.$t("PRICE_AND_PERSON_IS_REQUIRED"));
							}
						});
					}
					//#endregion
				} else {
					this.popupBatchUpdate.priceExtra.delete.hasRoomRate
						.filter((x) => this.popupBatchUpdate.select.roomType.includes(x.roomTypeId))
						.forEach((y) => {
							y.roomRates.filter((x) => this.popupBatchUpdate.select.ratePlan.includes(x.ratePlanId)).forEach((z) => {
								z.ota.filter((x) => this.popupBatchUpdate.select.ota.includes(x.ota.id)).forEach((i) => {
									let isValid = false;
									let tempDate = [];
									i.dates.forEach((t) => {
										if (t.value) {
											tempDate.push({
												apply: t.apply,
												value: t.value,
											});
											isValid = true;
										}
									});
									if (isValid) {
										body.push({
											id: i.roomrateId,
											numberPerson: i.numberPerson,
											extraType: this.popupBatchUpdate.priceExtra.extraTypeSelected,
											dates: tempDate,
										});
									}
								});
							});
						});
				}
			if (this.popupBatchUpdate.priceExtra.action == "massUpdate") {
				if (bodyMassUpdate.persons.length > 0) {
					bodyMassUpdate.persons.forEach(e => {
						e.extraMonday = this.formatMoney(+e.extraMonday, this.usedCurrency);
						e.extraTuesday = this.formatMoney(+e.extraTuesday, this.usedCurrency);
						e.extraWednesday = this.formatMoney(+e.extraWednesday, this.usedCurrency);
						e.extraThursday = this.formatMoney(+e.extraThursday, this.usedCurrency);
						e.extraFriday = this.formatMoney(+e.extraFriday, this.usedCurrency);
						e.extraSaturday = this.formatMoney(+e.extraSaturday, this.usedCurrency);
						e.extraSunday = this.formatMoney(+e.extraSunday, this.usedCurrency);
					})
					sale_room
						.massUpdateExtraPrice(bodyMassUpdate)
						.then((res) => {
							_alert(res, this.$t(res.data), false);
						})
						.finally(
						() => (
							(this.popupBatchUpdate.isLoading = false)
						)
					);
				} else {
					_alert(null, this.$t("PRICE_AND_PERSON_IS_REQUIRED"));
				}
			} else {
				if (body.length <= 0) {
					if (this.popupBatchUpdate.priceExtra.action == "update") {
						_alert(null, this.$t("PRICE_AND_PERSON_IS_REQUIRED"));
					} else {
						_alert(null, this.$t("VALUE_AND_PERSON_IS_REQUIRED"));
					}
				} else {
					this.popupBatchUpdate.isLoading = true;

					if (this.popupBatchUpdate.priceExtra.action == "update") {
						body.forEach(item => {
							item.persons.forEach(e => {
								e.extraMonday = this.formatMoney(+e.extraMonday, this.usedCurrency);
								e.extraTuesday = this.formatMoney(+e.extraTuesday, this.usedCurrency);
								e.extraWednesday = this.formatMoney(+e.extraWednesday, this.usedCurrency);
								e.extraThursday = this.formatMoney(+e.extraThursday, this.usedCurrency);
								e.extraFriday = this.formatMoney(+e.extraFriday, this.usedCurrency);
								e.extraSaturday = this.formatMoney(+e.extraSaturday, this.usedCurrency);
								e.extraSunday = this.formatMoney(+e.extraSunday, this.usedCurrency);
							})
						})
						sale_room
						.updateExtraPrice(body)
						.then((res) => {
							_alert(res, this.$t(res.data), false);
						})
						.finally(
							() => (
							(this.popupBatchUpdate.isLoading = false)
							)
						);
					} else {
						sale_room
						.deleteExtraPrice(body)
						.then((res) => {
							_alert(res, this.$t(res.data), false);
						})
						.finally(
							() => (
							(this.popupBatchUpdate.isLoading = false)
							)
						);
					}
				}
			} 
		},
	}
};
</script>